var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dc395f;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.1,0H1.9A1.9,1.9,0,0,0,0,1.9V19.1A1.9,1.9,0,0,0,1.9,21H19.1A1.9,1.9,0,0,0,21,19.1V1.9A1.9,1.9,0,0,0,19.1,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.41,10.235a4.366,4.366,0,0,1,.112-.949L1.47,5.36H0L.446,3.692H3.983L2.587,9.3a3.579,3.579,0,0,0-.131.863c0,.358.175.463.446.526A2.334,2.334,0,0,0,5.111,9.077L6.027,5.36H4.539l.447-1.669H8.168l-.41,1.895a3.613,3.613,0,0,1,2.773-2.058A2.177,2.177,0,0,1,12.67,5.994a4.84,4.84,0,0,1-.2,1.374l-.6,2.166a2.521,2.521,0,0,0-.093.584c0,.377.149.565.428.565s.633-.208,1.042-1.356l.819.32c-.484,1.715-1.358,2.43-2.456,2.43a1.709,1.709,0,0,1-1.9-1.828,3.356,3.356,0,0,1,.13-.941l.614-2.224a2.273,2.273,0,0,0,.093-.679A1.048,1.048,0,0,0,9.433,5.257c-.875,0-1.452.636-1.75,1.86L6.493,11.955H4.409l.373-1.52A2.959,2.959,0,0,1,2.27,12.085,1.68,1.68,0,0,1,.41,10.235Zm1.47-8.973A1.265,1.265,0,1,1,3.145,2.525,1.258,1.258,0,0,1,1.879,1.262Z",
    transform: "translate(3.962 4.16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInvision);
export default __webpack_public_path__ + "static/media/logo-invision.9914cf42b44071b5326f6ad315a83bba.svg";
export { ForwardRef as ReactComponent };